<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">Liste des utilisateurs</h3>
        </div>
        <div class="card-toolbar">
          <a class="btn btn-icon btn-sm btn-primary mr-1"  href="/#/user/nouveau">
            <i class="icon-md fas fa-plus"></i>
          </a>
          <a class="btn btn-icon btn-sm btn-danger mr-1"  v-b-modal.search>
            <i class="icon-md fas fa-search"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="1">
            <select class="form-control" v-model="datatable.limitPage" @change="datatableInit">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </b-col>
        </b-row>
        <b-table responsive striped hover ref="table" :items="datatable.data" :fields="fields" @sort-changed="sortChanged" show-empty empty-text="Il n'y a aucun enregistrement à afficher">
          <template #cell(nom)="data">
            <a :href="'/#/user/detail/'+data.item.id">{{ data.value }}</a>
          </template>
          <template #cell(role_id)="data">
            {{$store.back.getParamTitre(params.UserRole,data.value)}}            
          </template>
          <template #cell(status)="data">
            {{params.status.find(p => {return p.id == data.value}).titre}}
          </template>
          <template #cell(date_create)="data">
            {{$store.back.timestampToDate(data.value)}}
          </template>
        </b-table>
        <b-pagination size="lg" align="center" v-model="datatable.currentPage" @change="changePage" :total-rows="datatable.totalRow" :per-page="datatable.limitPage" aria-controls="itemList"></b-pagination>
      </div>
    </div>
    <b-modal id="search" title="Recherche" size="xl" ref="myModalDeleteRef">
      <div class="row">
        <div class="form-group col-md-4" v-for="(field,i) in fields.filter(f => f.searchable == true)" :key="i">
          <label>{{field.label}}</label>
          <input type="text" :placeholder="'Rechercher par '+field.label" :data-column="field.key" class="form-control">
        </div>
        <div class="form-group col-md-4">
          <label>Statut</label>
          <select class="form-control" data-column="status">
            <option value="">Tout</option>
            <option v-for="s in params.status" :value="s.id" :key="s.id">{{s.titre}}</option>
          </select>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right" @click="searchInit">
            Recherche
          </b-button>
          <b-button variant="danger" class="float-right mr-2" @click="$refs.myModalDeleteRef.hide();">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable:true,
          searchable:true
        },
        {
          key: 'nom',
          label: 'Nom',
          sortable:false,
          searchable:true
        },
        {
          key: 'prenom',
          label: 'Prenom',
          sortable:false,
          searchable:true
        },
        {
          key: 'email',
          label: 'Email',
          sortable:false,
          searchable:true
        },
        {
          key: 'role_id',
          label: 'Role',
          sortable:false,
          searchable:false
        },
        {
          key: 'status',
          label: 'Statut',
          sortable:false,
          searchable:false
        },
        {
          key: 'date_create',
          label: 'Date creation',
          sortable:true,
          searchable:false
        }
      ],
      datatable:{
        currentPage: 1,
        nextPage: 2,
        previousPage: 0,
        limitPage: 20,
        totalRow: 0,
        data: []
      },
      sort:{
        field: 'id',
        value: 'DESC'
      },
      searchQuery:null,
      params:{
        role:[],
        status:[]
      }
    };
  },
  components: {
  },
  watch: {
  },
  beforeMount() {
    let params = {
      modules: ["UserRole"]
    };
    this.$store.back.ajax('/magic/all', params, (res) => {
      if(res.status === true){
        this.params.UserRole = res.data['UserRole'];
        this.params.status = res.data['status'];
      }
    });
  },
  methods: {
    datatableInit: function(){
      var the = this
      this.$store.back.ajax('/user/liste?'+this.query,null,(res) => {
        the.datatable = res;
      });
    },
    sortChanged(e){
      this.sort = {
        field: e.sortBy,
        value: e.sortDesc === true ? "DESC" : "ASC"
      };
      this.datatable.data = [];
      this.datatableInit();
    },
    changePage(e){
      this.datatable.currentPage = e;
      this.datatableInit();
    },
    searchInit(){
      this.datatable.currentPage = 1;
      let query = {};
      let inputs  = document.querySelectorAll('[data-column]');
      inputs.forEach(elt => {
        let value  = elt.value;
        let key = elt.dataset.column;
        query[key] = value
      });
      if(Object.entries(query).length > 0){
        this.searchQuery = encodeURI(JSON.stringify(query));
      }else{
        this.searchQuery = null;
      }
      this.$refs.myModalDeleteRef.hide();
      this.datatableInit();
    },
  },
  computed: {
    query: function(){
      var sort = this.sort.field === null ? null : encodeURI(JSON.stringify(this.sort));
      return 'page='+this.datatable.currentPage+'&limit='+this.datatable.limitPage+'&sort='+sort+'&search='+this.searchQuery;
    }
  },
  mounted() {
    this.datatableInit();
  }
};
</script>
